const calculateDroppedEntitySize = (designWidth, designHeight, entityWidth, entityHeight) => {
  const ratio = entityWidth / entityHeight;
  let droppedWidth, droppedHeight, droppedScale;

  if (entityWidth >= designWidth) {
    droppedScale = ((designWidth * 100) / entityWidth - 4) / 100;
    droppedWidth = entityWidth * droppedScale;
    droppedHeight = droppedWidth / ratio;
  } else if (entityHeight >= designHeight) {
    droppedScale = ((designHeight * 100) / entityHeight - 4) / 100;
    droppedHeight = entityHeight * droppedScale;
    droppedWidth = droppedHeight * ratio;
  } else if (entityWidth > entityHeight) {
    droppedScale = ((designWidth * 100) / entityWidth - 4) / 100;
    droppedWidth = entityWidth * droppedScale;
    droppedHeight = droppedWidth / ratio;
  } else {
    droppedScale = ((designHeight * 100) / entityHeight - 4) / 100;
    droppedHeight = entityHeight * droppedScale;
    droppedWidth = droppedHeight * ratio;
  }

  return { droppedWidth, droppedHeight, droppedScale };
};

const removeAuthToken = (url = '') =>
  url
    .replace(/([?&])authToken=[^&#]*/g, '$1')
    .replace('?&', '?')
    .replace(/[?&](#|$)/, '$1');

export const normalizeFirstPartyMediaUrl = (url = '') => {
  if (!url || typeof window === 'undefined') return url;

  try {
    const parsedUrl = new URL(url, window.location.origin);
    const fileServer = process.env.REACT_APP_FILE_SERVER;
    const isApiMediaPath = /^\/api\/(?:resources|users)\//i.test(parsedUrl.pathname);
    const firstPartyHosts = new Set([
      window.location.hostname,
      'mondaa.ir',
      'www.mondaa.ir',
      'monda.ir',
      'www.monda.ir',
      'vibino.ir',
      'www.vibino.ir',
      'localhost',
      '127.0.0.1',
    ]);

    if (isApiMediaPath && firstPartyHosts.has(parsedUrl.hostname) && fileServer) {
      const fileServerUrl = new URL(fileServer, window.location.origin);
      const apiSuffix = parsedUrl.pathname.replace(/^\/api/i, '');
      parsedUrl.protocol = fileServerUrl.protocol;
      parsedUrl.hostname = fileServerUrl.hostname;
      parsedUrl.port = fileServerUrl.port;
      parsedUrl.pathname = `${fileServerUrl.pathname.replace(/\/$/, '')}${apiSuffix}`;
    } else if (
      window.location.protocol === 'https:' &&
      parsedUrl.protocol === 'http:' &&
      firstPartyHosts.has(parsedUrl.hostname)
    ) {
      parsedUrl.protocol = 'https:';
    }

    return parsedUrl.toString();
  } catch (error) {
    return url;
  }
};

export const generateImageLink = (imageUrl = '', authToken) => {
  const cleanUrl = normalizeFirstPartyMediaUrl(removeAuthToken(imageUrl));
  const isExportService =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/exportService/');
  if ((process.env.NODE_ENV !== 'development' && !isExportService) || !authToken) {
    return cleanUrl;
  }

  const separator = cleanUrl.includes('?') ? '&' : '?';
  return `${cleanUrl}${separator}authToken=${encodeURIComponent(authToken)}`;
};

export const getImageExtention = (imageUrl = '') => {
  const cleanUrl = removeAuthToken(imageUrl).split('#')[0].split('?')[0];
  const fileName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
  const extensionIndex = fileName.lastIndexOf('.');

  return extensionIndex === -1 ? '' : fileName.substring(extensionIndex + 1).toLowerCase();
};

export { calculateDroppedEntitySize };
